(() => {
  const updateProgress = () => {
    document.querySelectorAll('[data-bloom-progress]').forEach((el) => {
      const value = Number(el.dataset.bloomProgress || 0);
      el.style.setProperty('--progress', `${Math.max(0, Math.min(100, value))}%`);
    });
  };

  document.addEventListener('DOMContentLoaded', updateProgress);
  document.addEventListener('cart:updated', updateProgress);
  document.addEventListener('shopify:section:load', updateProgress);
})();

(() => {
  const sticky = document.querySelector('[data-bloom-sticky-atc]');
  if (!sticky) return;
  const stickyButton = sticky.querySelector('[data-bloom-sticky-button]');
  const mainButton = document.querySelector('.product-form__submit');
  if (!stickyButton || !mainButton) return;

  stickyButton.addEventListener('click', () => mainButton.click());
  const sync = () => {
    stickyButton.disabled = mainButton.disabled;
    stickyButton.textContent = mainButton.querySelector('span')?.textContent?.trim() || mainButton.textContent.trim();
    const visiblePrice = document.querySelector('.product__info-container .price-item--regular, .product__info-container .price-item--sale');
    const stickyPrice = sticky.querySelector('[data-bloom-sticky-price]');
    if (visiblePrice && stickyPrice) stickyPrice.textContent = visiblePrice.textContent.trim();
  };
  new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(sync, 80);
  });
  const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-hidden', entry.isIntersecting), { threshold: .2 });
  observer.observe(mainButton);
  sync();
})();
